import useApiRequest from "../common/useApiRequest";
import { useQuery } from "@tanstack/react-query";

type UsePermissionAccessListResult = {
  permissionAccessList: string[] | undefined;
  error: Error | null;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
};

/**
 * Hook to fetch user permission access list.
 */
export const usePermissionAccessList = (
  enabled: boolean
): UsePermissionAccessListResult => {
  const { GET } = useApiRequest();

  const fetchPermissionAccessList = async (): Promise<string[]> => {
    const permissionAccessList: string[] = await GET(
      "/api/user/me/permissions"
    );
    return permissionAccessList;
  };

  const { data, error, isLoading, isFetching, isError } = useQuery<
    string[],
    Error
  >({
    queryKey: ["permissionAccessList"],
    queryFn: fetchPermissionAccessList,
    enabled,
  });

  return {
    permissionAccessList: data,
    error: error ?? null,
    isLoading,
    isFetching,
    isError,
  } satisfies UsePermissionAccessListResult;
};
